import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import {
    BudgetUse,
    BudgetUseListResponse,
    BudgetUseQueryParams,
    CreateBudgetUse,
    ProductBudgetUseListResponse
} from '@frontend/budget/types';

export class BudgetUseClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async fetchBudgetUses(queryParams?: ApiQueryParams<BudgetUseQueryParams>, withCredentials?: Token): Promise<BudgetUseListResponse> {
        return await this.apiPaginated<BudgetUseListResponse, BudgetUseQueryParams>(`${this.endpoint}/budget-uses`, queryParams, withCredentials);
    }

    public static async resolveBudgetUses(ids: string[], field: string = 'id'): Promise<BudgetUseListResponse> {
        return this.resolve<BudgetUseListResponse>(`${this.endpoint}/budget-uses`, ids, field);
    }

    public static async postBudgetUse(accountId: string, userId: string, budgetUse: CreateBudgetUse): Promise<BudgetUse> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/users/${userId}/uses`, budgetUse);
        return await this.handleResponse<BudgetUse>(response);
    }

    public static async fetchBudgetUse(accountId: string, userId: string, budgetUseId: string): Promise<BudgetUse> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/users/${userId}/uses/${budgetUseId}`);
        return await this.handleResponse<BudgetUse>(response);
    }

    public static async deleteBudgetUse(accountId: string, userId: string, budgetUseId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/users/${userId}/uses/${budgetUseId}`);
        return await this.handleVoidResponse(response);
    }

    public static async fetchProductBudgetUses(
        accountId: string,
        userId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<ProductBudgetUseListResponse> {
        return await this.apiPaginated<ProductBudgetUseListResponse, DefaultQueryParams>(
            `${this.endpoint}/accounts/${accountId}/users/${userId}/product-budget-uses`,
            queryParams
        );
    }
}
